import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderContentGetAllBySlider } from '../../services';

export const fetchSliderContentGetAllBySlider = createAsyncThunk(
    'sliderContentGetAllBySlider/fetchSliderContentGetAllBySlider',
    async ({ id }) => {
        const response = await SliderContentGetAllBySlider(id)
        return response.result
    }
);

const sliderContentGetAllBySliderSlice = createSlice({
    name: 'sliderContentGetAllBySlider',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentGetAllBySlider.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentGetAllBySlider.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentGetAllBySlider.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentGetAllBySliderSlice.reducer;
